import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { WebHookService } from '../services/web-hook/web-hook.service';
import { catchError, exhaustMap, map, of, switchMap, tap } from 'rxjs';
import * as WebHookActions from './webhook-actions'
import { ToastService } from 'app/toast/services/toast.service';
import { WebHookFormModalService } from '../services/web-hook-form-modal/web-hook-form-modal.service';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

@Injectable()
export class WebHookEffects {

    public loadWebHookListEffect$ = createEffect(() =>{
        return this.actions$.pipe( 
              ofType(WebHookActions.loadWebHookList),
              exhaustMap((_: any) => {
                return this.webHookService.getWebHookList().pipe(
                  map((data:any[]) => WebHookActions.loadWebHookListSuccess({ webHookList:data })),
                  //catchError(error => of(P2PActions.loadP2PCampaignListFailure({ error }))))
                )
              })
            );
        });

        public loadFailedTransactions$ = createEffect(() =>{
            return this.actions$.pipe( 
                  ofType(WebHookActions.loadFailedTransactions),
                  exhaustMap((action) => {
                    return this.webHookService.getFailedTransactions(action.webHookId).pipe(
                      map((data: any[]) => WebHookActions.loadFailedTransactionsSuccess({ failedTransactions:data })),
                    )
                  })
                );
            });

        public resendFailedTransaction$ = createEffect(() => {
            return this.actions$.pipe(
              ofType(WebHookActions.resendFailedTransaction),
              exhaustMap((action) => {
                return this.webHookService.resend(action.webHookErrorId).pipe(
                    map((data: any[]) => WebHookActions.resendFailedTransactionSuccess({})),
                    tap(() => {
                        this.toastService.showSuccess("Transaction sent successfully");
                    }),
                    exhaustMap(_ => 
                    of(WebHookActions.loadFailedTransactions({ webHookId: action.webHookId }))
                    ),
                    catchError(error => {
                        if(error?.errorMessage){
                            this.webHookModalService.onResendError(error.errorMessage)
                        }
                        return of(WebHookActions.loadFailedTransactions({ webHookId: action.webHookId }));
                    })
                );
            })
            );
        });
              


        public deleteWebHook$ = createEffect(() =>{
            return this.actions$.pipe( 
                ofType(WebHookActions.deleteWebHook),
                exhaustMap((action) => {
                    return this.webHookService.delete(action.webHookId).pipe(
                        map((data: any[]) => WebHookActions.deleteWebHookSuccess()),
                        switchMap((data) => {
                            if(!action.onDetailsPage){
                              return of(WebHookActions.loadWebHookList({}))
                            }

                            return of(data);
                        }
                        ),
                        tap((data) => {
                            this.toastService.showSuccess(`Web hook deleted succesfully`)
                            if(action.onDetailsPage){
                                this.router.navigateByUrl('/integration/web-hook/list')
                            }
                        }),
                    )})
                );
            });

            public editWebHook$ = createEffect(() =>{
                return this.actions$.pipe( 
                    ofType(WebHookActions.editWebHok),
                    exhaustMap((action) => {
                        return this.webHookService.edit(action.webHookId,action.webHook,).pipe(
                            map(_ => WebHookActions.editWebHookSuccess({})),
                            tap(_ => {
                                
                                this.toastService.showSuccess("Web hook edited successfully")
                                this.webHookModalService.close();
                            }),
                            switchMap(_ => of(WebHookActions.loadWebHookList({})))
                        )})
                    );
                });

            public addWebHook$ = createEffect(() =>{
                return this.actions$.pipe( 
                    ofType(WebHookActions.addWebHook),
                    exhaustMap((action) => {
                        return this.webHookService.add(action.webHookToAdd).pipe(
                            map((data: any) => WebHookActions.addWebHookSuccess({ addedWebHook: data })),
                            tap(_ => {
                                this.toastService.showSuccess("Web hook added successfully")
                                this.webHookModalService.close();
                            }),
                            switchMap(_ => of(WebHookActions.loadWebHookList({}))),
                        )})
                    );
                });

            public testSendWebHook$ = createEffect(() =>{
                    return this.actions$.pipe( 
                    ofType(WebHookActions.testSendWebHook),
                    exhaustMap((action) => {
                        return this.webHookService.sendTestTransaction(action.webHookId).pipe(
                            map((data: any[]) => WebHookActions.testSendWebHookSuccess()),
                            tap((data) => {
                              this.toastService.showSuccess("Test transaction send successfully!")
                            }),
                            catchError(error => {
                                if(error?.errorMessage){
                                    this.webHookModalService.onTestSendError(error.errorMessage)
                                }
                                
                                return of()
                            })
                        )})
                    );
                });


    constructor(
        private actions$:Actions,
        private webHookService:WebHookService,
        private toastService : ToastService,
        private webHookModalService:WebHookFormModalService,
        private router: Router,
        private store:Store
    ){}
}